module.exports = "/_next/static/images/b1464c2758b0b0ae86538fa3f6533d5b-cajitas-left-desktop.jpg.webp";